import useOpenable from "@Front/Hooks/useOpenable";
import { useCloseOpenableOnEscape } from "@Front/Hooks/useCloseOpenableOnEscape";
import { useCloseOpenableOnOutsidePointer } from "@Front/Hooks/useCloseOpenableOnOutsidePointer";
import { useCloseOpenableOnPageShow } from "@Front/Hooks/useCloseOpenableOnPageShow";
import { useCloseOpenableOnRouteChange } from "@Front/Hooks/useCloseOpenableOnRouteChange";
import { Bars3BottomRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef } from "react";

import IconButton from "../../IconButton";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";
import BurgerModal from "./BurgerModal";
import classes from "./classes.module.scss";
import { WindowStore } from "@Front/Stores/WindowStore";

const headerBreakpoint = 1023;

export default function BurgerMenu(): React.ReactElement {
	const rootRef = useRef<HTMLDivElement>(null);
	const { isOpen, toggle, close } = useOpenable();
	useCloseOpenableOnRouteChange(isOpen, close);
	useCloseOpenableOnPageShow(isOpen, close);
	useCloseOpenableOnEscape(isOpen, close);
	useCloseOpenableOnOutsidePointer(isOpen, close, rootRef);

	useEffect(() => {
		const onResize = (window: Window): void => {
			if (window.innerWidth > headerBreakpoint && isOpen) close();
		};

		const windowResizeSubscription = WindowStore.getInstance().onResize((window: Window): void => onResize(window));

		return (): void => {
			windowResizeSubscription();
		};
	}, [close, isOpen]);

	return (
		<div className={classes["root"]} ref={rootRef}>
			{isOpen ? (
				<IconButton
					icon={<XMarkIcon />}
					onClick={toggle}
					ariaLabel={COMMON_UI_I18N.iconButtonAccessibilityLabels.closeMainMenu}
				/>
			) : (
				<IconButton
					icon={<Bars3BottomRightIcon />}
					onClick={toggle}
					ariaLabel={COMMON_UI_I18N.iconButtonAccessibilityLabels.openMainMenu}
				/>
			)}
			<BurgerModal isOpen={isOpen} closeModal={close} />
		</div>
	);
}
